import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  CreateCuentaTrabajoVesDTO,
  CuentaTrabajoVes,
} from '../interfaces/cuenta-trabajo-ves.interface';

@Injectable({
  providedIn: 'root',
})
export class CuentaTrabajoVesService {
  private API_URL = environment.apiGatewayURL;

  constructor(private http: HttpClient) {}

  getAllCuentaTrabajoVes(): Promise<CuentaTrabajoVes[]> {
    const serviceURL = `${this.API_URL}account/cuenta-trabajo-ves`;
    return firstValueFrom(this.http.get<CuentaTrabajoVes[]>(serviceURL));
  }

  getActiveCuentaTrabajoVes(): Promise<CuentaTrabajoVes[]> {
    const serviceURL = `${this.API_URL}account/cuenta-trabajo-ves/active`;
    return firstValueFrom(this.http.get<CuentaTrabajoVes[]>(serviceURL));
  }

  getCuentaTrabajoVes(id: number): Promise<CuentaTrabajoVes> {
    const serviceURL = `${this.API_URL}account/cuenta-trabajo-ves/${id}`;
    return firstValueFrom(this.http.get<CuentaTrabajoVes>(serviceURL));
  }

  createCuentaTrabajoVes(data: CreateCuentaTrabajoVesDTO): Promise<any> {
    const serviceURL = `${this.API_URL}account/cuenta-trabajo-ves`;
    return firstValueFrom(
      this.http.post<{ result: CuentaTrabajoVes }>(serviceURL, data)
    );
  }

  updateCuentaTrabajoVes(
    id: number,
    data: any
  ): Promise<{ result: CuentaTrabajoVes }> {
    const serviceURL = `${this.API_URL}account/cuenta-trabajo-ves-update/${id}`;
    return firstValueFrom(
      this.http.post<{ result: CuentaTrabajoVes }>(serviceURL, data)
    );
  }

  toggleCuentaTrabajoVesStatus(
    id: number,
    activa: boolean
  ): Promise<{ result: CuentaTrabajoVes }> {
    return this.updateCuentaTrabajoVes(id, { activa });
  }
}
